document.addEventListener("DOMContentLoaded", () => {
  initCaseStudyList();
  humbMenu();
});

const mql = window.matchMedia('screen and (max-width: 768px)');
const isSP = () => mql.matches;
mql.addEventListener("change", () => {
  initCaseStudyList();
});

let initialized = false;

function initCaseStudyList() {

  // 親要素を取得（data-list-more属性を持つ要素）
  const parentElements = document.querySelectorAll('[data-list-more]');

  parentElements.forEach(function (parent) {
    // data-list-moreの値を取得し、整数に変換
    const moreNum = getItemToShowNum(parent);

    // 要素を取得
    const listElem = parent.querySelector(".bnrItems");
    const moreButton = parent.querySelector('.button.more'); // MOREボタンのクラス名は'.more-button'としています

    // 親要素の子要素をすべて取得
    const childElements = listElem.children;
    // 一旦全ての子要素を表示
    Array.from(childElements).forEach(function (child) {
      child.classList.remove('hide');
    });
    // 初期表示件数を超えた子要素は非表示
    if (childElements.length > moreNum) {
      Array.from(childElements).forEach(function (child, index) {
        if (index >= moreNum) {
          child.classList.add('hide');
        }
      });
      moreButton.style.display = 'block';
    } else {
      moreButton.style.display = 'none';
    }
    // MOREボタンを初期化
    moreButton.innerHTML = "MORE";

    if (!initialized) {
      moreButton.addEventListener('click', handleClickMoreButton);

      function handleClickMoreButton() {
        // data-list-moreの値を取得し、整数に変換
        const itemsToShow = getItemToShowNum(parent);

        // 子要素のどれかにhideクラスが付いているかどうかを判定し、トグルする
        const isHidden = Array.from(childElements).some(child => child.classList.contains('hide'));
        if (isHidden) {
          // hideクラスが付いている場合、全てのhideクラスを削除
          Array.from(childElements).forEach(function (child) {
            child.classList.remove('hide');
          });
          moreButton.innerHTML = "CLOSE";
        } else {
          // hideクラスが付いていない場合、指定の件数以降に再度hideクラスを付与
          Array.from(childElements).forEach(function (child, index) {
            if (index >= itemsToShow) {
              child.classList.add('hide');
            }
          });
          moreButton.innerHTML = "MORE";
        }
      }
    }


    function getItemToShowNum(elem) {
      const moreNumPC = parseInt(elem.getAttribute('data-list-more'), 10);
      const moreNumSP = parseInt(elem.getAttribute('data-list-more-sp'), 10);
      return (isSP() && !isNaN(moreNumSP))? moreNumSP : moreNumPC;
    }
  });

  initialized = true;

}




function humbMenu() {
  //ボタンクリックでメニュー開閉
  var wrap = document.getElementById('humb');
  var btn = document.getElementById('button');
  btn.addEventListener('click', function () {
    var wrapClasss = wrap.classList;
    var wrapClass = Array.prototype.slice.call(wrapClasss);
    if (wrapClass.indexOf('is-click') != -1) {
      wrap.classList.remove('is-click');
    } else {
      wrap.classList.add('is-click');
    }
  });
  //メニュー内の項目をクリックしたらメニューを閉じる
  var menu = document.getElementById('menu');
  var targets = menu.getElementsByTagName('li');
  var target = Array.prototype.slice.call(targets);
  target.forEach(function (list) {
    list.addEventListener('click', function () {
      var wrapClasss = wrap.classList;
      var wrapClass = Array.prototype.slice.call(wrapClasss);
      if (wrapClass.indexOf('is-click') != -1) {
        wrap.classList.remove('is-click');
      }
    });
  });
}